import styled, { css } from 'styled-components';
import { Colors } from '../../styles/constants';

interface DiaCabecalhoProps {
  Disponivel?: boolean;
}

export const Container = styled.div`
  background-color: #fff;
  padding: 6px;
  margin: 10px;
  border: 1px solid #d7d7d7;
`;

export const NomeAgenda = styled.h6`
  color: ${Colors.info};
`;

export const FlexBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderAgenda = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 6px 0;

  button {
    & + button {
      margin-left: 4px;
    }
  }
`;

export const Calendario = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  height: 100vh;
  overflow-y: scroll;
`;

export const DiaCabecalho = styled.h5<DiaCabecalhoProps>`
  width: 100%;
  height: 18px;
  padding: 2px;
  margin-bottom: 0;
  text-align: center;
  font-size: 11px;
  text-transform: capitalize;
  border-top: 1px solid #d7d7d7;
  border-right: 1px solid #d7d7d7;
  border-left: 1px solid #d7d7d7;
  ${props =>
    !props.Disponivel &&
    css`
      background-color: #f6f6f6;
      cursor: not-allowed;
    `}
`;

export const Hora = styled.div`
  width: 45px;

  > div {
    border: 1px solid #d7d7d7;
    border-right-width: 0;
    height: 40px;
    line-height: 40px;

    text-align: center;

    span {
      vertical-align: super;
      font-size: 9px;
    }

    & + div {
      border-top-width: 0;
    }
  }
`;

export const DiasContainer = styled.div`
  display: flex;
  flex-grow: 1;
`;

export const Marcacao = styled.div`
  flex: 1;
  padding-bottom: 6px;

  > div {
    border: 1px solid #d7d7d7;

    & + div {
      border-top-width: 0;
    }
  }
`;

// export const AgendamentoContainer = styled.div`
//   //width: 96%;
//   height: 39px;
//   background-color: #cec0c0;
//   color: #fff;
//   position: absolute;
//   top: 18px;
//   display: flex;
//   //align-items: center;
//   border-radius: 4px;
//   padding: 4px 8px;

//   svg {
//     margin-right: 6px;
//   }
// `;
export const AgendamentoContainer = styled.div`
  // relative flex w-full flex-col items-center
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PreviousNextContainer = styled.div`
  // absolute top-1/2 flex w-full justify-between gap-4 lg:max-w-5xl
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 16px;
  top: 50%;
`;

export const ButtonPreviousNext = styled.button`
  // d-flex h-100 items-center gap-4 rounded border bg-white bg-opacity-60 p-2 hover:border-chumbo-50 hover:text-chumbo-800
  cursor: pointer;
  display: flex;
  border: 1px solid #e0d3d3;
  color: #54575b;
  background-color: #fff;
  height: 100%;
  border-radius: 4px;
  // padding: 12px 8px;
  font-weight: 500;
  padding: 0.5rem;
  &:hover {
    color: #4c4e50;
    border-color: #4c4e50;
  }
  span {
    display: inline-block;
    line-height: 1.3rem;
    padding-left: 0.5rem;
  }
`;

export const DiasUnidadeContainer = styled.div`
  // flex w-full justify-center px-2
  margin: 0 110px;
  display: flex;
  overflow: auto;
  z-index: 1;
  div {
    // snap mt-2 flex gap-x-3 text-white md:mt-0
    display: flex;
    justify-content: center;
    column-gap: 0.75rem;
    align-items: flex-start;
    div {
      // snap mt-2 flex gap-x-3 text-white md:mt-0
      display: flex;
      column-gap: 0.75rem;
    }
  }
`;
export const PData = styled.p`
  //mt-4  px-3 text-center text-sm
  margin-top: 16px;
  padding: 12px 0;
  text-align: center;
`;

export const CalendarioAddContainer = styled.div`
  display: flex;
  width: 100%;
  height: 40px;

  color: #a1a1a1;

  align-items: center;
  justify-content: center;
  //border: 1px solid #d7d7d7;

  /* & + div {
    border-top: 1px solid #d7d7d7;
  } */

  span {
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 14px;
    place-content: center;
    align-items: center;
    background-color: #f6f6f6;
    cursor: not-allowed;
  }
`;

export const ButtonAdd = styled.button`
  cursor: pointer;
  border: 0;
  background-color: transparent;
  width: 100%;
  height: 100%;

  &:hover {
    background-color: #e8e8e8;
    color: #000;
    font-weight: bold;
  }
`;

export const ButtonHorario = styled.button`
  cursor: pointer;
  border: 0;
  background-color: #02a002;
  /* width: 100%;
  height: 100%; */
  border-radius: 4px;
  padding: 12px 8px;
  font-weight: 500;
  &:hover {
    background-color: #067e06;
  }
`;

export const DiasHorarioContainer = styled.div``;

// rounded-lg bg-chumbo-600 px-3 py-2 text-center font-medium uppercase text-white
export const DataHorarioContainer = styled.div`
  border-radius: 4px;
  border: 0;
  background-color: #333333;
  width: 100%;
  justify-content: center;
  text-transform: uppercase;
  padding: 8px 0;
`;

// my-4 flex flex-wrap gap-2
export const HorarioContainer = styled.div`
  margin: 12px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
`;

export const AgendaDoDiaContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  column-gap: 20px;
  row-gap: 20px;

  @media (max-width: 800px) {
    grid-template-columns: auto auto auto;
  }

  @media (max-width: 580px) {
    grid-template-columns: auto auto;
  }
`;

export const AgendaDoDiaButton = styled.button<DiaCabecalhoProps>`
  position: relative;
  cursor: pointer;
  border: 1px solid ${props => (props.Disponivel ? '#28a745' : '#cecece')};
  border-radius: 4px;
  background-color: transparent;
  padding: 4px;
  height: 70px;

  h6 {
    font-size: 0.9rem;
    ${props =>
      props.Disponivel &&
      css`
        font-weight: bold;
      `}
  }

  svg {
    position: absolute;
    top: 5px;
    left: 8px;
  }

  &:hover {
    background-color: #e8e8e8;
    color: #000;
    font-weight: bold;
  }
`;
